import { ChangeDetectionStrategy, Component } from '@angular/core'

@Component({
  selector: 'albert-landing-page',
  standalone: true,
  imports: [],
  templateUrl: './landing-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LandingPageComponent {
}
